<template>
  <div class="kpt-logged-out">
    <div class="columns">
      <div class="kpt-logged-out-background column">
        &nbsp;
      </div>
      <div class="kpt-logged-out-content column">
        <div class="kpt-logged-out-box card">
          <div class="card-header">
            <div class="card-header-title">
              Logged Out
            </div>
          </div>
          <div class="card-content">
            <div class="content">
              <p>You've been logged out due to inactivity or network connectivity interruption.</p>
              <p>You can refresh the page, or click below to verify your credentials and log in again.</p>
            </div>
            <div class="buttons">
              <b-button @click="refresh" type="is-primary">Log In</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    refresh() {
      const keys = Object.keys(localStorage);
      if (keys) {
        keys.forEach(key => { if (key.includes('oidc.')) localStorage.removeItem(key) })
      }
      const sessionKeys = Object.keys(sessionStorage);
      if (sessionKeys) {
        sessionKeys.forEach(key => { if (key.includes('oidc.')) sessionStorage.removeItem(key) })
      }
      window.location.reload();
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';
.kpt-logged-out {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  background: $white;

  .columns {
    height: 100%;

    .column:first-child {
      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    .column {
      height: 100%;
    }
  }

  .kpt-logged-out-background {
    background-image: url('~@/assets/logout-background.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .kpt-logged-out-content {
    position: relative;

    .kpt-logged-out-box {
      position: absolute;
      min-height: 220px;
      min-width: 550px;
      top: calc(50% - 110px);
      left: 50px;
      border-top: 2px solid $blue;
      z-index: 999;

      @media screen and (max-width: 1370px) {
        left: 0;
      }

      @media screen and (max-width: 1080px) {
        left: -275px;
      }

      @media screen and (max-width: 768px) {
        position: relative;
        margin: 0 auto;
        left: auto;
      }
    }
  }
}
</style>
